module.exports = {"TXTWCL_WEXLL_BE_BACK_SOONX":{"id":"TXTWCL_WEXLL_BE_BACK_SOONX","defaultMessage":"NOUS SERONS BIENTÔT DE RETOUR !"}}